import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { AthleteEnergyExpenditureHistoryQuery } from "../../../../types";
import { calculateHistoricalAverages } from "./utils";

interface HistoricalTableFooterRowProps {
  groupedData: Map<string, AthleteEnergyExpenditureHistoryQuery["athleteEnergyExpenditureHistory"]["edges"]>;
  weekRange: string | null;
}

export const HistoricalTableFooterRow: React.FC<HistoricalTableFooterRowProps> = ({ groupedData, weekRange }) => {
  const cellStyle = {
    fontWeight: 600,
    color: "text.secondary",
    background: "#f2f4f7",
    borderBottom: "1px solid #eaecf0",
  };

  const averages = calculateHistoricalAverages(groupedData);

  const formatValue = (value: number | null) => {
    if (value === null) return "—";
    return `${Math.round(value).toLocaleString()} kcal`;
  };

  return (
    <TableRow>
      <TableCell sx={cellStyle} colSpan={3}>{weekRange ? `Average for ${weekRange}` : "Average"}</TableCell>
      <TableCell sx={cellStyle} align="right">{formatValue(averages.avgTdee)}</TableCell>
      <TableCell sx={cellStyle} align="right">{formatValue(averages.avgActiveEnergy)}</TableCell>
      <TableCell sx={cellStyle} align="right">{formatValue(averages.avgRestingEnergy)}</TableCell>
      <TableCell sx={cellStyle} align="right">{formatValue(averages.avgTargetIntake)}</TableCell>
      <TableCell sx={cellStyle} align="right">{formatValue(averages.avgLoggedIntake)}</TableCell>
      <TableCell sx={cellStyle} align="right">{formatValue(averages.avgEnergyBalance)}</TableCell>
    </TableRow>
  );
};
